import { render, staticRenderFns } from "./Nature.md?vue&type=template&id=5e79f5a5&"
import script from "./Nature.md?vue&type=script&lang=js&"
export * from "./Nature.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports